@if (showSearch()) {
    <div class="d-flex justify-content-end flex-wrap align-content-center px-2">
        <input
            #consoleSearch
            type="text"
            class="form-control shadow-sm"
            [value]="searchTerm()"
            [placeholder]="'common.form.label.search' | translate"
            (input)="onSearch($event)"
        />
    </div>
}

<div class="console-container d-flex justify-content-start flex-wrap align-content-center pe-3" [dir]="languageService.direction()">
    @for (item of displayedConsoleItems(); track item) {
        <adaa-console-icon [item]="item" *adaaHasPermission="getPermission(item.permissions)" />
    }
</div>
